import { ReactNode } from 'react';

import { Link } from 'react-router-dom';

import { Breadcrumbs } from '../../types/breadcrumbs';

interface HeaderAreaProps {
  breadcrumbs?: Breadcrumbs;
  children?: ReactNode;
}

export default function HeaderArea({ breadcrumbs, children }: HeaderAreaProps) {
  const Breadcrumbs = breadcrumbs?.map(([to, label], i) => {
    return (
      // We can use index as keys as long as breadcrumbs don't change position.
      <li key={i} className="breadcrumb">
        {i < breadcrumbs.length - 1 ? <Link to={to}>{label}</Link> : label}
      </li>
    );
  });

  return (
    <header className="header-area mb-4">
      {Breadcrumbs && <ol className="breadcrumbs mb-4">{Breadcrumbs}</ol>}
      {children}
    </header>
  );
}
